import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";

import { formatVolume } from "@/components/Dispatch/format";
import type { DriverRow } from "@/types/driver";
import ContextTile from "./ContextTile";
import { NO_VALUE } from "./contextFormat";

/** The device volume, or that it is muted. */
export default function VolumeTile({ driver }: { driver: DriverRow }) {
  const value = driver.mostRecentVolumeAudible === false ? "Muted" : formatVolume(driver.volume) || NO_VALUE;
  return <ContextTile icon={<VolumeUpOutlinedIcon sx={{ fontSize: 18 }} />} label="Volume" value={value} />;
}
